import { FormErrors } from 'redux-form';

import { SalesCardState } from 'components/settings/reducers/sections/salesforceCards';

import type { ValidateErrors } from '../cards.types';

export function validate(values: SalesCardState): FormErrors {
  const errors: ValidateErrors = { hook: {} };

  if (!values) {
    return errors;
  }

  if (!values?.hook?.title?.trim()) {
    errors.hook.title = 'Please add a title';
  }

  if (!values?.hook?.consumer_key?.trim()) {
    errors.hook.consumer_key = 'Please add a consumer key';
  }

  if (!values?.hook?.consumer_secret?.trim()) {
    errors.hook.consumer_secret = 'Please add a consumer secret';
  }

  if (!values?.hook?.security_token?.trim()) {
    errors.hook.security_token = 'Please add a security token';
  }

  if (!values?.hook?.account_email?.trim()) {
    errors.hook.account_email = 'Please add an account email';
  }

  if (!values?.hook?.account_password?.trim()) {
    errors.hook.account_password = 'Please add an account password';
  }

  if (!values?.template?.trim()) {
    errors.template = 'Please add some template content';
  }

  return errors;
}
